import useToggleSdkContext from 'utils/useToogleSdk'
import useKinerjaTipeContext from 'app/KinerjaShared/hooks/useKinerjaTipeContext'

import type { KinerjaTipe } from 'types/kinerja'

export function useKinerjaTipe(): {
  isEnabled: boolean
  tipe: KinerjaTipe | undefined
} {
  const toggles = useToggleSdkContext()
  const isEnabled = toggles?.['kinerja-with-tipe-enabled'] === true
  const tipeContext = useKinerjaTipeContext()

  if (!Object.hasOwn(tipeContext, 'tipe')) {
    throw new Error('useKinerjaTipe must be used within a KinerjaTipeProvider')
  }

  if (!toggles) {
    throw new Error('useKinerjaTipe must be used within a ToggleSdkProvider')
  }

  if (!isEnabled) {
    return {
      isEnabled: false,
      tipe: undefined,
    }
  }

  return {
    isEnabled,
    tipe: tipeContext.tipe,
  }
}
